import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiInstance } from "../../api/apiInstance"
import anchor from '../../../constants/anchor'
import { marketplacesSettings } from '../../../types/sales/salesTypes'

const setMarketplacesSettings = (data: marketplacesSettings, marketplace: string) => async(
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const config = {
        headers: {
            Authorization: `${anchor} ${localStorage.getItem('accessToken')}`
        }
    }
    const params = {
        userId: userData.smsAuth.userId,
        data,
        marketplace,
    }
    try {
        const { data: { status, data } } = await apiInstance.post('/sales/marketplaces/setMarketplacesSettings', params, config)
        if(status === 'ok') {
            dispatch(({
                type: storeDispatchTypes.setMarketplacesSettings,
                value: data,
            }))
        }

    } catch (e) {
        console.error('set marketplace settings failed', e)
    }
}

export default setMarketplacesSettings
